var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-checkbox",on:{"click":function($event){$event.stopPropagation();return _vm.onChange.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.iconSrc,"width":"20","height":"20","alt":"","draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }